import { AccountDetailsWebComponent } from './component/AccountDetailsWebComponent';
import { WEB_COMPONENT_ACCOUNT_DETAILS } from '../../../webcomponents.constants';

export { AccountDetailsWebComponent };

window.customElements.define(WEB_COMPONENT_ACCOUNT_DETAILS, AccountDetailsWebComponent);
